export default {
  default: () => import("/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/layouts/default.vue").then(m => m.default || m),
  full: () => import("/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/layouts/full.vue").then(m => m.default || m)
}